export const Location = {
  assign(url) {
    window.location.assign(url);
  }
};
